import {
  disableTestEnvironment,
  enableTestEnvironment,
  getCustomers,
  transferTestEnvironmentToProduction,
  updateCustomer
} from 'redux/api/internal/Customers'

import { Dispatch } from 'redux'

import { ApplicationState } from 'redux/Stores/types'
import { PatchInternalCustomerBody } from 'types/GlobalCustomer'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

function tryGetAllCustomers() {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    const { fetchStatus } = getState().InternalCustomerStore

    if (fetchStatus === 'fetching' || fetchStatus === 'success') {
      return
    }

    dispatch(actions.getAll())

    getCustomers()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryUpdateCustomer(id: string, body: PatchInternalCustomerBody) {
  return (dispatch: Dispatch) => {
    updateCustomer(id, body)
      .then((response) => {
        dispatch(actions.updateOneSuccess(response.data.data))
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {})
  }
}

function tryToggleTestEnvironment(id: string, enable: boolean) {
  return (dispatch: Dispatch) => {
    const request = enable
      ? enableTestEnvironment(id)
      : disableTestEnvironment(id)

    return request
      .then(() => getCustomers())
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

function tryTransferTestEnvironmentToProduction(id: string) {
  return (dispatch: Dispatch) => {
    return transferTestEnvironmentToProduction(id)
      .then(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export const useInternalCustomerActions = () => {
  return {
    tryGetAllCustomers: useThunkActions(tryGetAllCustomers),
    tryUpdateCustomer: useThunkActions(tryUpdateCustomer),
    tryToggleTestEnvironment: useThunkActions(tryToggleTestEnvironment),
    tryTransferTestEnvironmentToProduction: useThunkActions(
      tryTransferTestEnvironmentToProduction
    )
  }
}
